import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Certifications", "Сертификаты"][index],
        placeholder: ["ID, Name", "ID, название"][index],
        addLabel: ["Add Certificate", "Добавить Сертификат"][index],
    };
};
